__turbopack_context__.v({
  "artwork": "ProductConfigurator-module-scss-module__AYwZ1G__artwork",
  "canvas": "ProductConfigurator-module-scss-module__AYwZ1G__canvas",
  "check": "ProductConfigurator-module-scss-module__AYwZ1G__check",
  "checkboxControl": "ProductConfigurator-module-scss-module__AYwZ1G__checkboxControl",
  "customizerLayout": "ProductConfigurator-module-scss-module__AYwZ1G__customizerLayout",
  "editorActions": "ProductConfigurator-module-scss-module__AYwZ1G__editorActions",
  "editorButton": "ProductConfigurator-module-scss-module__AYwZ1G__editorButton",
  "editorCard": "ProductConfigurator-module-scss-module__AYwZ1G__editorCard",
  "editorCardHeader": "ProductConfigurator-module-scss-module__AYwZ1G__editorCardHeader",
  "editorDanger": "ProductConfigurator-module-scss-module__AYwZ1G__editorDanger",
  "editorField": "ProductConfigurator-module-scss-module__AYwZ1G__editorField",
  "editorGrid": "ProductConfigurator-module-scss-module__AYwZ1G__editorGrid",
  "editorHeader": "ProductConfigurator-module-scss-module__AYwZ1G__editorHeader",
  "editorPrimary": "ProductConfigurator-module-scss-module__AYwZ1G__editorPrimary",
  "editorRoot": "ProductConfigurator-module-scss-module__AYwZ1G__editorRoot",
  "editorSection": "ProductConfigurator-module-scss-module__AYwZ1G__editorSection",
  "editorToolbar": "ProductConfigurator-module-scss-module__AYwZ1G__editorToolbar",
  "error": "ProductConfigurator-module-scss-module__AYwZ1G__error",
  "eyebrow": "ProductConfigurator-module-scss-module__AYwZ1G__eyebrow",
  "field": "ProductConfigurator-module-scss-module__AYwZ1G__field",
  "fieldGrid": "ProductConfigurator-module-scss-module__AYwZ1G__fieldGrid",
  "fields": "ProductConfigurator-module-scss-module__AYwZ1G__fields",
  "geometryGrid": "ProductConfigurator-module-scss-module__AYwZ1G__geometryGrid",
  "header": "ProductConfigurator-module-scss-module__AYwZ1G__header",
  "help": "ProductConfigurator-module-scss-module__AYwZ1G__help",
  "imagePlaceholder": "ProductConfigurator-module-scss-module__AYwZ1G__imagePlaceholder",
  "inlineActions": "ProductConfigurator-module-scss-module__AYwZ1G__inlineActions",
  "keyboardHint": "ProductConfigurator-module-scss-module__AYwZ1G__keyboardHint",
  "layerControls": "ProductConfigurator-module-scss-module__AYwZ1G__layerControls",
  "layerHeader": "ProductConfigurator-module-scss-module__AYwZ1G__layerHeader",
  "localeTab": "ProductConfigurator-module-scss-module__AYwZ1G__localeTab",
  "localeTabActive": "ProductConfigurator-module-scss-module__AYwZ1G__localeTabActive",
  "localeTabs": "ProductConfigurator-module-scss-module__AYwZ1G__localeTabs",
  "nestedCard": "ProductConfigurator-module-scss-module__AYwZ1G__nestedCard",
  "notice": "ProductConfigurator-module-scss-module__AYwZ1G__notice",
  "numberWithUnit": "ProductConfigurator-module-scss-module__AYwZ1G__numberWithUnit",
  "preview": "ProductConfigurator-module-scss-module__AYwZ1G__preview",
  "printSurface": "ProductConfigurator-module-scss-module__AYwZ1G__printSurface",
  "quote": "ProductConfigurator-module-scss-module__AYwZ1G__quote",
  "required": "ProductConfigurator-module-scss-module__AYwZ1G__required",
  "root": "ProductConfigurator-module-scss-module__AYwZ1G__root",
  "statusMessage": "ProductConfigurator-module-scss-module__AYwZ1G__statusMessage",
  "success": "ProductConfigurator-module-scss-module__AYwZ1G__success",
  "surfaceControls": "ProductConfigurator-module-scss-module__AYwZ1G__surfaceControls",
  "surfacePreviewArea": "ProductConfigurator-module-scss-module__AYwZ1G__surfacePreviewArea",
  "surfaceSection": "ProductConfigurator-module-scss-module__AYwZ1G__surfaceSection",
  "template": "ProductConfigurator-module-scss-module__AYwZ1G__template",
  "templateGrid": "ProductConfigurator-module-scss-module__AYwZ1G__templateGrid",
  "wide": "ProductConfigurator-module-scss-module__AYwZ1G__wide",
});
